import React from 'react'

export default function Music() {
    return (
        <svg 
            xmlns="http://www.w3.org/2000/svg" 
            width='14px'
            height='14px'
            viewBox="0 0 218.911 218.911">

            <path 
                fill="currentColor"            
                d="M170.975,49.667c-1.143-1.672-2.298-3.205-3.433-4.553c-8.974-10.66-24.952-19.393-42.742-23.36  c-11.391-2.542-24.952-14.857-29.21-19.383c-2.644-2.822-7.118-3.252-10.324-0.602c-1.741,1.44-2.647,3.658-2.648,5.918  l-0.005,10.175l-0.005,9.994c0,0,0,0,0,0l-0.06,124.317c-4.072-1.647-8.464-2.516-12.995-2.518  c-19.083,0-34.617,15.526-34.626,34.61c-0.009,19.094,15.517,34.635,34.611,34.645c0.001,0,0.015,0,0.016,0  c19.085,0,34.619-15.526,34.627-34.611v0c0,0,0,0,0,0l0.054-112.369c3.936,1.326,8.534,2.349,13.901,2.827  c20.538,1.829,34.369,5.939,43.527,12.933c6.839,5.223,7.11,7.762,7.215,8.324c0,0.013,0,0.026,0,0.039  c0.011,0.786,0.699,1.396,1.485,1.396l6.119,0.004v0v0l2.8,0.001c2.596,0.001,4.701-2.102,4.702-4.697V92.71  C183.992,77.021,179.493,62.137,170.975,49.667z M69.553,211.41L69.553,211.41L69.553,211.41L69.553,211.41z"/>
        </svg>
    )
}